export const FIELD_VARIANT = {
  FILLED: 'filled',
  INVALID: 'invalid',
  EDIT: 'edit',
} as const;

export type FieldVariant = (typeof FIELD_VARIANT)[keyof typeof FIELD_VARIANT];
